var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.6154H4.38462V7.15385H19.6154V18.2308H21V5.76923H14.0769L12 3H3V21H20.187L21 19.6154ZM4.38462 5.76923V4.38462H11.2969L12.3689 5.76923H4.38462Z",
    fill: "#111113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46154 12.6923V14.0769H17.5385V12.6923H6.46154Z",
    fill: "#111113"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5385 16.1538H6.46154V17.5385H17.5385V16.1538Z",
    fill: "#111113"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6923 9.23077H6.46154V10.6154H12.6923V9.23077Z",
    fill: "#111113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDocuments);
export default __webpack_public_path__ + "static/media/folder-documents.e9d24b3bb81f2bf2cb5429025f0b348f.svg";
export { ForwardRef as ReactComponent };